export default __webpack_public_path__ + "static/media/visa-small.d3df2796.svg";